import { createAction } from '@reduxjs/toolkit';

export const storeEventTypeAction = createAction<string>('STORE_EVENT_TYPE');

export const storeLocationAction = createAction(
  'STORE_LOCATION',
  (location: string, lat: string, lng: string) => {
    return {
      payload: {
        location,
        lat,
        lng,
      },
    };
  },
);

export const storePeopleNumberAction = createAction<string>('STORE_PEOPLE_NUMBER');
